<template>
    <div v-if="structure.length > 0" class="quiz-wrapper">
        <h4 class="mb-5">{{quiz.text}}</h4>

        <b-card class="shadowed p-4">
            <b-form @submit="onSubmit">
                <div v-for="(question, index) in structure" :key="question.question.id" class="mb-5">
                    <h5 class="mb-2">{{index + 1}}. {{question.question.text}}</h5>
                    <radio-group
                        :options="question.answers"
                        @onSelected="onSelectCallback"
                        :index="index"
                        :disabled="quiz.readonly"
                        :label="trans('courses.quiz.click_to_answer')"
                        :selected-id="getSelectedId(question.answers)"
                    />
                </div>
                <div class="d-flex flex-column" v-if="!quiz.readonly">
                    <p class="text-right">{{ trans('courses.quiz.answer_all') }}</p>
                    <div class="justify-content-end d-flex text-right">
                         <b-button type="submit" variant="secondary" :disabled="!isAbleToSubmit">{{ trans('courses.quiz.calculate') }}</b-button>
                    </div>
                </div>
                <div v-else class="d-flex flex-column text-center pt-2">
                    <p><strong>{{ trans('courses.quiz.your_rating_is') }}</strong></p>
                    <div class="d-flex justify-content-center mb-3">
                        <score-hearts
                            :score="quiz.final_score"
                            variant="secondary"
                            v-bind:scale="1.25"
                        />
                    </div>
                    <h5>{{ trans('courses.quiz.now_continue') }}</h5>
                </div>
            </b-form>
        </b-card>
    </div>
</template>

<script>
    import RadioGroup from "../molecules/form/RadioGroup"
    import ScoreHearts from "../molecules/ScoreHearts"

    export default {
        name: "QuizContainer",
        components: { RadioGroup, ScoreHearts },
        props: {
            quizId: String,
            pageId: String,
            moduleId: Number,
            courseId: Number,
            quizData: Object
        },
        data() {
            return {
                selectedAnswers: [],
                quiz: {},
                structure: [],
                score: [],
                isAbleToSubmit: false
            }
        },
        mounted() {
            this.getQuiz();
        },
        methods:{
            onSubmit(evt) {
                evt.preventDefault()

                const data = {
                    page_id: this.pageId,
                    answers: this.selectedAnswers
                }

                this.$axios.post(`/api/rest/programs/${this.courseId}/modules/${this.moduleId}/pages/${this.pageId}/quiz/${this.quizId}/submit`, data )
                    .then((res)=>{
                        this.quiz.final_score = res.data.score;
                        this.quiz.readonly = true
                    })
                    .catch((e)=>{
                        console.log(e);
                    })
            },
            getQuiz(){
                this.quiz = this.quizData.quiz
                this.structure = this.quizData.structure
                trackEvent("pageQuizView", { quizId: this.quizId, quizName: this.quiz.text })
            },

            onSelectCallback(index, selected, score) {
                this.selectedAnswers[index] = JSON.stringify(selected)
                this.score[index] = score

                this.buttonEnabled()
            },

            buttonEnabled: function () {
                return this. isAbleToSubmit = !this.selectedAnswers.includes(undefined) && this.selectedAnswers.length === this.structure.length
            },

            getSelectedId(options) {
                const selectedItem = options.filter(function( option ) {
                    return option.is_selected === true;
                })
                return selectedItem.length > 0 ? selectedItem[0].value : null
            }
        }
    }
</script>

<style lang="scss" scoped>
    .quiz-wrapper {
        max-width: 738px;
        margin: 0 auto;
    }
</style>
